export default __webpack_public_path__ + "static/link-label-dont-613661a3c43591c1a783b37ad7da0936.png";